@if (appeals$ | async; as appeals) {
	@if (appeals.data && appeals.data.length) {
		<div class="statements">
			<div class="statements__title-block">
				<div class="statements__title-block-icon">
					<app-svg-documents
						width="100%"
						height="100%"
					></app-svg-documents>
				</div>
				<h3 class="statements__title-block-text">
					{{ title }}
				</h3>
			</div>
			<div class="statements__title-block">
				<h3
					class="statements__sub-title-block-text"
					#statementsHeader
				>
					Ваши обращения
				</h3>
			</div>

			<div class="references-block__list-wrapper">
				<app-list
					[items]="appeals.data"
					[defaultLimitTo]="5"
					[expandStep]="5"
					[expandLabel]="'Показать еще'"
					[collapseLabel]="'Скрыть'"
				>
					<ng-template let-item>
						<div
							class="statements__item"
							[id]="'statements__item' + item.regNumber"
						>
							<app-appeal-item
								[item]="item"
								(viewedAppeal)="viewedAppeal($event)"
							></app-appeal-item>
						</div>
					</ng-template>
				</app-list>
			</div>
		</div>
	}
}
